import { BASE_ASSETS } from "@assets/templates/constants";
import type { TemplateDefinition } from "@assets/templates/types";
import { DocumentInputContentV1 } from "@demo/types/documentContent";

export const vqaDemoExample: TemplateDefinition = {
  mode: "compose",
  slug: "vqa-demo-example",
  version: 1,
  title: "Media",
  description: "Assess visual context",
  thumbnailUuid: BASE_ASSETS.vqaDemoExample.uuid,
  assets: [BASE_ASSETS.vqaDemoExample],
  request: {
    model: "perceptron-mk1.5",
    system: [],
    user: [
      {
        type: "media",
        value: [
          {
            type: "image",
            value: {
              uuid: BASE_ASSETS.vqaDemoExample.uuid,
              extension: BASE_ASSETS.vqaDemoExample.extension,
              annotations: { points: [], boundingBoxes: [] },
            },
          },
        ],
      },
      {
        type: "paragraph",
        value: { type: "text", value: "Point to the focal point of this scene" },
      },
    ],
    outputAnnotations: true,
    variables: {},
    annotationFormat: "box",
    enableThinking: false,
  } satisfies DocumentInputContentV1,
};
